export default "assets/images/icons/back-arrow-c54da77f.svg";